import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import addEventListener from 'rc-util/lib/Dom/addEventListener';
import { Input as AntdInput,} from 'antd';
import Row from './row';
import Col from './col';
let Input=null;
process.env.__CLIENT__ && require('./msgcode.less');
export default class MsgCode extends Component {
  constructor(props) {
    super(props);
    const { cStyle } = props;
    let config = {};
    if (cStyle) {
      try {
        config = JSON.parse(cStyle);
      } catch (e) {
        console.error('msgcode--cStyle预制错误');
      }
    }
    this.state = Object.assign({
      focusedIndex: 0,
      phone:'',
      time: 60,
      msgQty:4,
      error:'', //验证码已失效请重新获取
      classname:'',
      focues:false
    },config);
    this.InitModel(this.state.msgQty);
    this.loading = true; // 计时器正在进行
    this.timer=null;
    this.time = Number(config.time) || 60;
    Input =  cb.rest.terminalType === 2 ? require('yxyweb/common/components/common/KeyboardInput').default : AntdInput;
    Input = AntdInput;
  }
  InitModel = (msgQty) => {
    let obj = {};
    for (var i = 0; i < msgQty; i++) {
      let model = new cb.models.SimpleModel();
      obj['input' + i] = model;
    }
    this.setState(obj);
    this.focusI = 0;
  }
  componentWillMount(){
    this.setState({error:'', value:''})
    this.props.model && this.props.model.setValue(null);
    clearInterval(this.timer);
  }
  componentDidMount() {
    if (this.props.model)
      this.props.model.addListener(this);
    // let refInput = cb.dom(findDOMNode(this.refs['input']));
    // setTimeout(() => {
    //   refInput.length && refInput[0].focus();
    // },10)
    // this.refs.input.refs.input.focus()
    this.onMouseDown = addEventListener(document, 'keydown', this.onKeyDown);
    clearInterval(this.timer)
  }
  starttimeout = ()=>{
    let _time1 = this.time
    const _time2 = this.time
    this.timer = setInterval(() => {
      this.setState({ time: (_time1--)}, () => {
        if (_time1 === 0) {
          clearInterval(this.timer);
          this.setState({
            time: _time2
          })
          this.loading = false
        }
      });
    }, 1000);
  }
  componentWillUnmount() {
    if (this.props.model)
      this.props.model.removeListener(this);
    this.onMouseDown.remove();
    this.onMouseDown = null;
  }
  onMouseDown=()=>{

  }
  onKeyDown = (event) => {
    // var parent = cb.dom(event.target).parents('.ant-modal-wrap');
    // if (parent && parent.length > 0 && (event.key == 'Backspace' || event.keyCode == 8))
    //   this.onDelete()
  }
  // componentWillUpdate(nextProps, nextState) {
  //   if (this.state.focusedIndex != nextState.focusedIndex || this.focusI != nextState.focusedIndex) {
  //     let refInput = cb.dom(findDOMNode(this.refs['input' + nextState.focusedIndex]));
  //     setTimeout(() => {
  //       refInput.length && refInput[0].focus();
  //     }, 0)
  //   }
  // }
  onDelete = () => {
    let { value ,msgQty} = this.state;
    value=value.substr(0,value.length-1)
    let i = value ?(value.length>=msgQty ? msgQty-1 : value.length):0
    this.setState({value});
    this.props.model.setValue(value);
    this.setState({},()=>{
      this.refs['input'].refs.input.focus()
    })
  }
  onFocus = () => {
    let {value} = this.state;
    this.refs['input'].refs.input.focus()
    this.refs['input'].refs.input.value=value
    this.setState({focues:true})
  }
  onBlur=(e)=>{
    let { msgQty } = this.state;
    let newVal = e.target.value;
    if(newVal.length>msgQty) newVal.length=length;
    if (this.props.model){this.props.model.setValue(newVal)}
    this.setState({focues:false})
  }
  handelInputClick=()=>{
     var obj = this.refs['input'].refs.input;
    obj.focus();
    var len = obj.value.length;
    if (document.selection) {
      var sel = obj.createTextRange();
      sel.moveStart('character', len);
      sel.collapse();
      sel.select();
    } else if (typeof obj.selectionStart === 'number' && typeof obj.selectionEnd === 'number') {
      obj.selectionStart = obj.selectionEnd = len;
    }
    this.setState({focues:true})
  }
  onValChange = (e) => {
    let { msgQty } = this.state;
    let newVal = e.target.value;
    if(newVal.length>msgQty) newVal.length=length;
    if (this.props.model){this.props.model.setValue(newVal)}
    this.setState({value:newVal},function(){
      this.onFocus()
    })
  }
  handelclick=()=>{
    if(!this.loading){
      this.loading = true
      this.props.model.setValue(null);
      this.setState({value:'',time:this.time,error:''})
      this.props.model.execute('afterHandleOK', { key: 'MsgCode'});
    }
    this.onFocus()
  }
  getControl = () => {
    let { value, msgQty ,phone,time,error,classname,focusedIndex,focues} = this.state;
    value=value || "";
    let controls = [];
    let _valueArr = value.split('');
    for(let i=0;i<msgQty;i++){controls.push(<p>
      {_valueArr[i]}
    </p>)}
    return <div className={'msgcode '+classname} style={{width:80*msgQty+'px'}}>
    <div className='msgcode-phonenum'>{phone?'请输入'+phone+'收到的短信验证码':null}</div>
      <div colCount={msgQty} className="msgcode-yxy">
        <Input autofocus='autofocus' ref={'input'} maxLength={msgQty} value={value} onBlur={e=>{this.onBlur(e)}} 
        onClick={()=>this.handelInputClick()} onChange={e => this.onValChange(e)} style={{width:"100%!important"}} />
        <div className="msgcode-yxy-box">
          {controls}
          {focues?<span style={{left:(value.length===msgQty?295:40+80*(value.length))+'px'}}></span>:null}
          {/*focues?<span style={{left:(value.length===msgQty?395:39+82*(value.length))+'px'}}></span>:null*/}
        </div>
      </div>
      <div className='msgcode-info'>
        <span className='msgcode-err'>{error}</span>
        {
          !this.loading && time==this.time ?
          <span onClick={this.handelclick} className={'msgcode-btn'}>重新获取?</span> :
          <span className={'msgcode-btn msgcode-btn-disabled'}>重新获取?</span> 
        }
        <span className='msgcode-time'> {time<this.time?time+'S后重新发送':null } </span>
      </div>
      
    </div>
  }
  render() {
    const msgCodeControl = this.getControl();
    return msgCodeControl;
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/msgcode.jsx